import React from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroductionToJupiterMedia() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section data-section-id="510" id="the-private-agent-os" className="relative w-full overflow-hidden bg-[#0A0A0C] py-20 lg:py-32 dark">
      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: `
            linear-gradient(to right, rgba(255,255,255,0.03) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.03) 1px, transparent 1px),
            radial-gradient(circle at 50% 50%, rgba(139, 92, 246, 0.08) 0%, transparent 70%)
          `,
      backgroundSize: "40px 40px, 40px 40px, 100% 100%",
      maskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
      WebkitMaskImage: "linear-gradient(to bottom, black 60%, transparent 100%)"
    }} aria-hidden="true" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-sans font-bold text-5xl md:text-6xl lg:text-[72px] leading-[1.1] text-white tracking-tighter">
              The OS for <br />
              <span className="text-primary">Private Agents.</span>
            </h1>

            <p className="font-mono text-lg md:text-[18px] leading-relaxed text-zinc-400 max-w-2xl">
              Local-first. iMessage-native. Secure. qOS is a deployable agent 
              operating environment featuring built-in Identity, Soul, Tools, and Memory. 
              Run private workflows on dedicated hardware with absolute data 
              sovereignty and approval-based execution.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button asChild className="bg-primary hover:bg-primary/90 text-white h-12 px-8 rounded-[6px] text-base font-medium shadow-lg shadow-primary/20 transition-all hover:-translate-y-0.5 animate-pulse">
                <Link to="/QOSByQuotientPage">
                  Request Access
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="border-white/10 text-white hover:bg-white/5 h-12 px-8 rounded-[6px] text-base font-medium bg-transparent transition-transform hover:-translate-y-0.5">
                <Link to="#the-private-agent-os">
                  Explore qOS
                </Link>
              </Button>
            </div>

            {}
            <div className="flex flex-wrap items-center gap-8 pt-8 border-t border-white/10 mt-4">
              <div className="flex flex-col">
                <span className="font-mono text-2xl text-white">Identity</span>
                <span className="text-sm text-zinc-500 font-sans">
                  Core
                </span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-white/10" />
              <div className="flex flex-col">
                <span className="font-mono text-2xl text-white">Soul</span>
                <span className="text-sm text-zinc-500 font-sans">
                  Agent Memory
                </span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-white/10" />
              <div className="flex flex-col">
                <span className="font-mono text-2xl text-white">Skills</span>
                <span className="text-sm text-zinc-500 font-sans">
                  Performance
                </span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-white/10" />
              <div className="flex flex-col">
                <span className="font-mono text-2xl text-white">Security</span>
                <span className="text-sm text-zinc-500 font-sans">
                  Enterprise Grade
                </span>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative h-[500px] lg:h-[600px] w-full flex items-center justify-center transition-all duration-1000 delay-200 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gradient-to-tr from-primary/20 to-transparent rounded-full blur-3xl" />

            {}
            <div className="absolute top-10 right-0 lg:-right-10 w-3/4 lg:w-[85%] z-10 transform transition-transform duration-700 hover:scale-105 hover:z-30">
              <div className="relative rounded-[12px] overflow-hidden shadow-2xl shadow-black/60 bg-[#121214] p-2 border border-white/10">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605362/img/mac_mini_space_gray.png" alt="Mac mini hardware running qOS" className="w-full h-auto object-cover rounded-[8px]" />
                {}
                <div className="absolute -bottom-4 -left-4 bg-[#1A1A1E] border border-white/10 shadow-xl py-2 px-4 rounded-[6px] flex items-center gap-2 backdrop-blur-md">
                  <div className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" />
                  <span className="font-mono text-xs font-bold text-zinc-300">
                    STATUS: SECURE
                  </span>
                </div>
              </div>
            </div>

            {}
            <div className="absolute bottom-10 left-0 lg:-left-10 w-3/4 lg:w-[80%] z-20 transform transition-transform duration-700 hover:scale-105">
              <div className="relative rounded-[12px] overflow-hidden shadow-2xl shadow-primary/10 bg-[#121214] p-2 border border-white/10">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605362/img/qos_command_interface.png" alt="qOS iMessage command interface" className="w-full h-auto object-cover rounded-[8px]" />
                {}
                <div className="absolute top-4 right-4 bg-primary text-white py-1 px-3 rounded-[4px] text-xs font-mono font-bold tracking-wide uppercase shadow-md">
                  Active
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}